import React from "react";
import "ant-design-draggable-modal/dist/index.css";
import { useDispatch } from "react-redux";
import { deleteWidgetInSheet } from "../../../appRedux/actions/Actions";

const SetWidget = ({ widgetId }) => {
   const dispatch = useDispatch();

   const deleteItem = () => {
      dispatch(deleteWidgetInSheet(widgetId));
   };
   return (
      <>
         <span
            onClick={deleteItem}
            className="span-style gx-text-primary icon icon-close"
            size="2x"
         />
      </>
   );
};

export default SetWidget;
